export default __webpack_public_path__ + "static/media/Cape of Illusions.44e61572.jpg";